// @ts-nocheck
import * as actions from '../../action-types';
import * as mutations from '../../mutation-types';

export default {
  [actions.CLEAR_LOCATION_SUGGESTIONS]: ({ commit }) => {
    commit(mutations.RESET_LOCATION_SUGGESTIONS);
  },
};
